module.exports = __webpack_public_path__ + "img/container-storage.ab893fc7.svg";